import Image, { StaticImageData } from 'next/image';
import Link from 'next/link';

import { useMediaQuery } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';

import styles from './JobCategoryButton.module.scss';

type JobCategoryButtonProps = {
  title: string;
  url: string;
  imageSrc: StaticImageData;
};

export const JobCategoryButton = ({ title, url, imageSrc }: JobCategoryButtonProps) => {
  const isDesktop = useMediaQuery('(min-width: 880px)');
  return (
    <Link tabIndex={0} href={url} as={url} prefetch={false}>
      <div className={styles.jobButton}>
        <div className={styles.jobButtonContent}>
          <h3 className={styles.jobButtonTitle}>{title}</h3>
          {/* TODO - change to jobNumber when we can add job count */}
          <div className={styles.jobsPill}>
            <SearchIcon />
          </div>
        </div>

        {isDesktop && (
          <div className={styles.jobButtonImageWrapper}>
            <Image
              className={styles.jobButtonImage}
              src={imageSrc}
              alt={title}
              height={262}
              width={440}
              priority={false}
              objectFit="cover"
            />
          </div>
        )}
      </div>
    </Link>
  );
};
